function malaria(){
    return{
        "games":[
            {
                "informs":[
                    {
                        "text":"O mosquito infectado pica o homem e inocula o plasmódio na corrente sanguínea, este vai para o fígado e se multiplica podendo invadir hemácias, onde se desenvolve gerando gametócitos.",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/malaria/1.png"
                    },
                    {
                        "text":"Nesse ciclo, dito esporogonia, o homem é o hospedeiro intermediário. Ao picar um doente, o mosquito sadio ingere os gametócitos, que no interior do vetor se fecundam e se desenvolvem nas formas ativas do parasita.",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/malaria/1.png"
                    },
                    {
                        "text":"O vetor é o hospedeiro definitivo do plasmódio neste ciclo chamado de esquizogonia.",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/malaria/1.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/malaria/1.jpg"
            },
            {
                "informs":[
                    {
                        "text":"A Malária é causada por protozoários do gênero Plasmodium: Plasmodium <i>falciparum</i>, P. <i>vivax</i>, P. <i>malariae</i>, P. <i>ovale</i> que ocorre apenas na África e P. <i>knowlesi</i> do Sudeste Asiático.",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/malaria/2.png"
                    },
                    {
                        "text":"Estão presentes no Brasil as três primeiras espécies, sendo predominantes infecções por P. <i>vivax</i>, seguidas de P. <i>falciparum</i>.",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/malaria/2.png"
                    },
                    {
                        "text":"O período de incubação (desde a picada até a manifestação dos sintomas) varia entre as espécies: para P. <i>falciparum</i> de 8 a 12 dias; P. <i>vivax</i>, 13 a 17 dias e P. <i>malariae</i>, 18 a 30 dias.",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/malaria/2.png"
                    }
                ],  
                "pathImageGame":"midias/images/games/puzzles/malaria/2.jpg"
            },
            {
                "informs":[
                    {
                        "text":"Quando as hemácias se rompem liberando parasitas, a pessoa sente febre alta, calafrios, tremores e transpira muito, sintomas que duram de 15min a 1h.",
                        "title":"Quais os sintomas da doença?",
                        "image":"images/games/informs/malaria/3.png"
                    },
                    {
                        "text":"Tais sintomas diminuem por um tempo, e voltam a ocorrer no mesmo dia ou com intervalos variáveis, caracterizando a febre intermitente.",
                        "title":"Quais os sintomas da doença?",
                        "image":"images/games/informs/malaria/3.png"
                    },
                    {
                        "text":"Se não tratada corretamente, a doença pode evoluir para sua forma mais grave apresentando os sintomas: convulsão, anemia intensa, hemorragias, pressão baixa, alteração de consciência, delírio e coma.",
                        "title":"Quais os sintomas da doença?",
                        "image":"images/games/informs/malaria/3.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/malaria/3.jpg"
            },
            {
                "informs":[
                    {
                        "text":"A transmissão da doença ocorre através da picada de vetor, o mosquito fêmea Anopheles, infectado por protozoários do gênero Plasmodium, sendo as espécies P. <i>falciparum</i>, P. <i>vivax</i> e P. <i>malariae</i> as mais comuns no Brasil.",
                        "title":"Como a doença é transmitida?",
                        "image":"images/games/informs/malaria/4.png"
                    },
                        {
                        "text":"São consideradas formas raras de transmissão da doença: a transfusão de sangue e uso compartilhado de seringas contaminadas.",
                        "title":"Como a doença é transmitida?",
                        "image":"images/games/informs/malaria/4.png"
                    },
                            {
                        "text":"Mais rara ainda é a transmissão vertical (de mãe para filho), e a transmissão direta de uma pessoa para outra é praticamente inexistente.",
                        "title":"Como a doença é transmitida?",
                        "image":"images/games/informs/malaria/4.png"
                        }
                ],
                "pathImageGame":"midias/images/games/puzzles/malaria/4.jpg"
            },
            {
                "informs":[
                    {
                    "text":"Como ainda não existe vacina contra a Malária, as medidas de proteção individual e combate ao vetor são as mais efetivas para prevenção.",
                    "title":"Como fazer a prevenção?",
                        "image":"images/games/informs/malaria/5.png"
                    },
                    {
                        "text":"Recomenda-se usar roupas de manga longa e calças compridas durante atividades de exposição elevada e nos horários crepusculares cuja atividade do vetor é mais intensa.",
                        "title":"Como fazer a prevenção?",
                        "image":"images/games/informs/malaria/5.png"
                    },
                        {
                        "text":"Usar telas em portas e janelas, mosquiteiros impregnados com inseticida e repelente na pele exposta seguindo a orientação do fabricante sobre o prazo para reaplicação do produto.",
                        "title":"Como fazer a prevenção?",
                        "image":"images/games/informs/malaria/5.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/malaria/5.jpg"
            }
        ]
    };
}

export {malaria};